import { render, staticRenderFns } from "./ActiveInactiveStatusView.vue?vue&type=template&id=4b6a16a4&scoped=true&"
import script from "./ActiveInactiveStatusView.vue?vue&type=script&lang=ts&"
export * from "./ActiveInactiveStatusView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6a16a4",
  null
  
)

export default component.exports